const article = {
  breadcrumb_home: '首页',
  breadcrumb_categories: '分类浏览',
  author_prefix: '作者：',
  publish_date: '发布日期：',
  read_time: '阅读时间：',
  minute: '分钟',
  back_to_list: '返回列表',
};

export default article;